import { cleanup, render, screen } from '@testing-library/react';
import * as React from 'react';

import translations from '../../translations';
import Unsorted from './unsorted';

translations.init();

function TestComponent() {
  return <Unsorted />;
}

describe('unsorted icon', () => {
  afterEach(() => {
    cleanup();
  });

  test('should render the unsorted icon', () => {
    render(<TestComponent />);
    const svg = screen.getByTestId('unsorted');

    expect(svg).toBeDefined();
    expect(svg.firstChild.nodeName.toLowerCase()).toBe('path');
  });
});
